// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { FundOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// project import
import { COMMISSION_OPTIMIZER_PATH } from 'constants/routeConstants';

// icons
const icons = { FundOutlined };

// ==============================|| MENU ITEMS - BUSINESS STRATEGY ||============================== //

const businessStrategy: NavItemType = {
  id: 'business-strategy-menu',
  type: 'group',
  children: [
    {
      id: 'business-strategy',
      title: <FormattedMessage id="business-strategy" />,
      type: 'collapse',
      icon: icons.FundOutlined,
      defaultOpen: false,
      children: [
        {
          id: 'commission-optimizer',
          title: <FormattedMessage id="commission-optimizer" />,
          type: 'item',
          url: COMMISSION_OPTIMIZER_PATH
        }
      ]
    }
  ]
};

export default businessStrategy;
